import React from 'react';
import Grid from '@material-ui/core/Grid';

const GridContainer = (props) => <Grid container={true} spacing={2}>{props.children}</Grid>;

export default GridContainer;
